<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="80">
       <template slot="imageSlot" slot-scope="{ row }">
        <div style="display: flex; align-items: center">
          <el-popover placement="right-start" title="" trigger="hover">
            <div style="width: 250px; height: 250px">
              <el-image
                :src="`${row.image}`"
                style="width: 100%; height: 100%"
              >
                <el-image
                  slot="error"
                  :src="no_pic"
                  style="width: 100%; height: 100%"
                ></el-image>
              </el-image>
            </div>
            <el-image
              slot="reference"
              :src="`${row.image}`"
              style="width: 60px; height: 60px; margin-top: 5px"
            >
              <el-image
                slot="error"
                :src="no_pic"
                style="width: 60px; height: 60px; margin-top: 5px"
              ></el-image>
            </el-image>
          </el-popover>
        </div>
      </template>
      <template slot="statusSlot"  slot-scope="{row}">
        {{operateStatusMap[row.status] || ''}}
      </template>
    </TableList>
    <el-pagination
        v-if="pages.total > 0"
        :style="{ padding: '8px 16px', textAlign: 'right' }"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageNo"
        :page-sizes="[20, 50, 100]"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.total"
      ></el-pagination>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import tableMixins from '@mixins/table-mixins';
import no_pic from "@/assets/images/no_pic.png";
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { PROD_MODIFY_STATUS } from '../dictionary'

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    pages: {
      type: Object,
      default() {
        return {
          total: 0,
          pageNo: 1,
          pageSize: 20,
        };
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(240)],
  components: {
    TableList,
  },
  data() {
    return {
      cols: [
        { prop: "image", attrs: { label: "图片", width: "90px" }, slot: true },
        { prop: "outerId", attrs: { label: "款式编码"} },
        { prop: "skuOuterId", attrs: { label: "商品编码" } },
        { prop: "erpOuterId", attrs: { label: "ERP主商家编码" }},
        { prop: "erpSkuOuterId", attrs: { label: "ERP规格商家编码" }},
        { prop: "title", attrs: { label: "商品名称" }},
        { prop: "status", attrs: { label: "状态" },slot: true },
        {prop: "editContent", attrs: { label: "详情" }}
      ],
      no_pic,
      statusMap:{
        0: '失败',
        1: '成功'
      }
    };
  },
  computed: {
    ...mapGetters(['routerPrefix', 'distributorDetail'],),
    operateStatusMap(){
      let map = {}
      PROD_MODIFY_STATUS.forEach(item => {
        map[item.value] = item.label
      });
      return map
    },
  },
  methods: {
    ...mapMutations(['setCurrentPage']),
    ...mapActions(['setRePublishRowData', 'setDisplayRePublishRowData', 'setDistributorDetail']),
    handleSizeChange(val) {
      console.log(this.pages,`每页 ${val} 条`);
      this.$emit('search', {...this.pages, pageNo:1, pageSize: val});
    },
    handleCurrentChange(val) {
      console.log(this.pages, val, '0-0-0-0-');
      this.$emit('search', {...this.pages, pageNo: val});
    }
  },
};
</script>

<style lang="scss" scoped>
.errorMessage{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

</style>
